import React from 'react';


import Custom from '../Home/CustomChatBot';
import Footer from '../Home/Footer';
import Navbar from '../Home/NavBar/NavBar';
import Blog from './Blogs';
import Contact from '../Home/Contact';

export default function BlogsPage(props){
    const {theme, setTheme} = props;
    return(
        <div>
            <Navbar theme={theme} setTheme={setTheme} />
            <Blog />
            {/* <Contact /> */}
            <Custom />
            <Footer theme={theme} />
        </div>
    )
}